// Coordinate helpers — keep bad input from ever reaching Firestore or a render
// (the store-edit crash class). Pure + unit-tested.

// Finite number or null (never NaN). Accepts numbers or numeric strings.
export function toFiniteOrNull(v) {
  if (v === '' || v === null || v === undefined) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

// Format a coordinate for display; missing/non-finite → em dash (so a store
// without coordinates shows "—", not a misleading "0.000000").
export function fmtCoord(v, digits = 6) {
  if (v === null || v === undefined || v === '') return '—';
  const n = Number(v);
  return Number.isFinite(n) ? n.toFixed(digits) : '—';
}

// If a single field holds a pasted "lat, lng" pair (as copied from Google Maps),
// split it. Returns { lat, lng } of finite numbers, or null if not a pair.
export function parseLatLngPair(str) {
  if (typeof str !== 'string' || !str.includes(',')) return null;
  const parts = str.split(',').map((s) => s.trim());
  if (parts.length !== 2) return null;
  const lat = toFiniteOrNull(parts[0]);
  const lng = toFiniteOrNull(parts[1]);
  return lat != null && lng != null ? { lat, lng } : null;
}

export const isLat = (n) => Number.isFinite(n) && n >= -90 && n <= 90;
export const isLng = (n) => Number.isFinite(n) && n >= -180 && n <= 180;
